import { render } from "./ScrollingImageInFrame.vue?vue&type=template&id=e717a3e4&scoped=true"
import script from "./ScrollingImageInFrame.vue?vue&type=script&lang=js"
export * from "./ScrollingImageInFrame.vue?vue&type=script&lang=js"

import "./ScrollingImageInFrame.vue?vue&type=style&index=0&id=e717a3e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e717a3e4"]])

export default __exports__